export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat("ru-RU").format(value);
};

export const formatPrice = (price: string | number): string => {
  if (typeof price !== "number") {
    return price.toString();
  }
  return new Intl.NumberFormat("ru-RU").format(price);
};
